export const page = {
	title: "Products",
	description: "Listing and configuration of items sold to final customers.",
	permissionError: "You don't have the permissions",
	addProduct: "Add product",
	bulkImportProducts: "Bulk import products",
	batchActions: "Batch actions",
	exportAllProducts: "Export all products via Excel",
	editAllProducts: "Edit all products",
	downloadAllProducts: "Download table with all products",
};
